import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import {
  checkIfSerialNumberExists,
  updateCompany,
} from "../../../../actions/clients/company/company";
import { Modal } from "react-bootstrap";

class CompanyDevicesModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      serial_number: this.props.device ? this.props.device.serial_number : "",
      type: this.props.device ? this.props.device.type : "",
      serialNumberError: null,
    };
  }

  handleSubmit() {
    const device = {
      serial_number: this.state.serial_number,
      type: this.state.type,
    };

    const currentDevices = [...this.props.company.devices];

    if (this.props.device && this.props.device.serial_number) {
      const deviceIndex = currentDevices.findIndex(
        (d) => d.serial_number === this.props.device.serial_number,
      );

      currentDevices[deviceIndex] = device;
    } else {
      currentDevices.push(device);
    }

    const data = {
      ...this.props.company,
      devices: currentDevices,
    };

    this.props.onCompanyEdit(
      data,
      () => this.props.close(),
      (e) => console.log(e),
    );
  }

  hasEmptyField() {
    return !this.state.serial_number || !this.state.type;
  }

  hasError() {
    return this.state.serialNumberError;
  }

  render() {
    return (
      <Modal
        show={true}
        size="md"
        onHide={() => this.props.close()}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FormattedMessage
              id={this.props.device ? "Modify.Device" : "Device.Add"}
            />
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="form-group row">
            <label htmlFor="serial_number" className="col-5 col-form-label">
              <FormattedMessage id="Serial.Number" />
            </label>
            <div className="col-7">
              <input
                type="text"
                id="serial_number"
                name="serial_number"
                className="form-control"
                defaultValue={this.state.serial_number}
                onInput={(e) =>
                  (e.target.value = ("" + e.target.value).toUpperCase())
                }
                onChange={(e) =>
                  this.setState({
                    serial_number: e.target.value,
                  })
                }
                onBlur={() =>
                  this.state.serial_number !== "" &&
                  this.props.onCheckIfSerialNumberExists(
                    this.state.serial_number,
                    (company) => {
                      this.setState({
                        serialNumberError: (
                          <FormattedMessage
                            id="Device.Already.Exists"
                            values={{ companyName: company.name }}
                          />
                        ),
                      });
                    },
                    () => {
                      this.setState({ serialNumberError: null });
                    },
                  )
                }
              />
              <small className="text-danger">
                {this.state.serialNumberError}
              </small>
            </div>
          </div>

          <div className="form-group row">
            <label htmlFor="type" className="col-5 col-form-label">
              <FormattedMessage id="Type" />
            </label>
            <div className="col-7">
              <select
                id="search_role"
                className="form-control form-control-sm mr-sm-3"
                onChange={(e) => {
                  this.setState({
                    type: e.target.value,
                  });
                }}
                value={this.state.type}
              >
                <option value="">
                  {this.props.intl.formatMessage({ id: "Select" })}
                </option>
                <option value="desk">
                  {this.props.intl.formatMessage({ id: "Terminal" })}
                </option>
                <option value="tablet">
                  {this.props.intl.formatMessage({ id: "Tablet" })}
                </option>
              </select>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-4 m-auto">
              <button
                disabled={this.hasEmptyField() || this.hasError()}
                className="btn btn-info btn-block button-info right"
                onClick={() => this.handleSubmit()}
              >
                <FormattedMessage id={this.props.device ? "Edit" : "Create"} />
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onCompanyEdit: (data, successCallback, failureCallback) =>
      dispatch(updateCompany(data, successCallback, failureCallback)),
    onCheckIfSerialNumberExists: (
      serialNumber,
      existsCallback,
      noExistsCallback,
    ) =>
      checkIfSerialNumberExists(serialNumber, existsCallback, noExistsCallback),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CompanyDevicesModal));
